import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import { submit, destroy } from 'redux-form';
import { connect } from 'react-redux';

import { AccentColor } from 'helpers/AccentColorHelper';
import * as submitValidator from 'helpers/SubmitValidator';
import { getTranslatedString } from 'helpers/i18n';

import { toggleMaintenanceDispatchOnProperty } from 'actions/landlordPropertiesActions';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import AssignToBankAccount from 'components/landlord_app/properties/components/AssignToBankAccount';
import UserShowingsForm from 'navigation/UserShowingsForm';

const dialogTypes = {
  MAINTENANCE_DISPATCH: 'maintenance_dispatch',
};

class AbstractDialog extends Component {
  UNSAFE_componentWillMount() {
    this.setState({
      portfolio: {
        value: null,
        label: '',
      },
      portfolioName: '',
    });
  }

  handlePortfolio = values => {
    if (values) {
      this.setState({
        portfolioName: '',
        portfolio: {
          label: values.label,
          value: values.value,
          error: '',
        },
      });
    }
  };

  submitPropertyShowingPreferences = formData => {
    formData.id = this.props.data.id;
    this.props.submitPropertyShowingPreferences(formData);
  };

  submitBankAccount = formData => {
    let { account_name, selected_account, account_number } = formData;
    let account_id = selected_account ? selected_account.value : undefined;

    let result = submitValidator.assignBankAccountToProperty(
      account_name,
      account_id,
      this.props.accounts
    );

    if (result) {
      this.props.assignAccount({
        account_name,
        account_id,
        property_id: this.props.data.id,
        account_number,
      });
      this.props.destroyRemoteBankAccountForm();
    }
  };

  handlePortfolioText = value => {
    if (value) {
      this.setState({
        portfolioName: value.target.value,
      });
    }
  };

  saveToClipboard = link => {
    link.select();
    document.execCommand('copy');
  };

  render() {
    const styles = {
      dialog: {
        content: {
          width: '50%',
          paddingBottom: '10px !important',
        },
        body: {
          padding: '0px 25px 10px 25px',
          textAlign: 'center',
          color: 'rgba(78, 78, 78, 0.85)',
          fontSize: '16px',
          overflow: 'auto',
        },
        actions: {
          paddingLeft: '25px',
          paddingRight: '25px',
        },
      },

      bookingLink: {
        title: {
          textAlign: 'center',
          fontSize: '28px',
        },
        text: {
          paddingBottom: '10px',
        },
        link: {
          color: '#242424',
          textAlign: 'center',
          fontSize: '26px',
          width: '100%',
          border: 'none',
        },
      },

      inactivateProperty: {
        title: {
          textAlign: 'center',
          fontSize: '28px',
        },
      },
    };

    let [title, titleStyle, body, actions] = ['', {}, '', []];
    const data = this.props.data;
    if (this.props.type === 'bookingLink') {
      const { text, link } = styles.bookingLink;
      title = 'Booking Link';
      titleStyle = styles.bookingLink.title;
      body = (
        <div>
          <p style={text}>
            Paste this booking link into all of your online advertisements to allow prospective{' '}
            <TenantResidentVerbiageHelper />s to book appointments. Click to copy link.
          </p>
          <a href={data.booking_link} target="_blank" style={link} rel="noopener noreferrer">
            {data.booking_link}
          </a>
          <input
            style={{ position: 'fixed', top: '0', left: '0', zIndex: '-10' }}
            ref={link => (this.bookingLink = link)}
            defaultValue={data.booking_link}
          />
        </div>
      );
      actions.push(
        <FlatButton
          label="Close"
          primary={false}
          onClick={this.props.handleClose}
          style={{ userSelect: 'auto', float: 'left' }}
        />,
        <FlatButton
          label="Copy"
          primary={true}
          keyboardFocused={true}
          onClick={() => this.saveToClipboard(this.bookingLink)}
        />
      );
    } else if (this.props.type === 'applicationLink') {
      const { text, link } = styles.bookingLink;
      title = 'Application Link';
      titleStyle = styles.bookingLink.title;
      body = (
        <div>
          <p style={text}>
            Paste this application link into all of your online advertisements to allow prospective{' '}
            <TenantResidentVerbiageHelper />s to apply to rent using our online application form.
          </p>
          <a href={data.application_link} target="_blank" style={link} rel="noopener noreferrer">
            {data.application_link}
          </a>
          <input
            style={{ position: 'fixed', top: '0', left: '0', zIndex: '-10' }}
            ref={link => (this.applicationLink = link)}
            defaultValue={data.application_link}
          />
        </div>
      );
      actions.push(
        <FlatButton
          label="Close"
          primary={false}
          onClick={this.props.handleClose}
          style={{ userSelect: 'auto', float: 'left' }}
        />,
        <FlatButton
          label="Copy"
          primary={true}
          keyboardFocused={true}
          onClick={() => this.saveToClipboard(this.applicationLink)}
        />
      );
    } else if (this.props.type === 'assignToPortfolio') {
      title = 'Assign To Portfolio';
      titleStyle = styles.inactivateProperty.title;
      body = (
        <div>
          <p style={{ fontSize: '14px' }}>
            Assigning a property to a portfolio allows you to group properties together for
            reporting and other functions.
          </p>

          <MultiSelectExtended
            allowNone
            name="portfolio_select"
            hintText="Portfolio"
            onChange={this.handlePortfolio}
            elementHeight={50}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            menuCloseButton={
              <FlatButton label="close" hoverColor={AccentColor()} style={{ float: 'left' }} />
            }
            data={this.props.portfolios}
            style={{
              marginTop: '-10px',
              fontSize: '14px',
              textAlign: 'left',
              width: '100%',
            }}
            createText="Create New Portfolio"
            createComponent={
              <div>
                <TextField
                  floatingLabelText="Portfolio Name"
                  fullWidth
                  value={this.state.portfolioName}
                  onChange={this.handlePortfolioText}
                />
                <p
                  style={{
                    color: AccentColor(),
                    fontSize: '11px',
                    textAlign: 'center',
                  }}
                >
                  {this.props.error}
                </p>
              </div>
            }
          />
        </div>
      );

      actions.push(
        <FlatButton
          label="Close"
          primary={false}
          onClick={this.props.handleClose}
          style={{ float: 'left' }}
        />,
        <FlatButton
          label="Assign"
          primary={true}
          keyboardFocused={true}
          onClick={() => {
            this.props.assignPortfolio(
              this.state.portfolioName,
              this.state.portfolio.value,
              data.id
            );
          }}
        />
      );
    } else if (this.props.type === 'propertyShowings') {
      title = 'Property Availability';
      titleStyle = styles.inactivateProperty.title;
      body = (
        <div>
          <p style={{ fontSize: '14px' }}>Create your availability preferences below.</p>
          <UserShowingsForm
            onSubmit={this.submitPropertyShowingPreferences}
            availability={data.availability}
            initialValues={data.availability}
          />
        </div>
      );
    } else if (this.props.type === 'assignToBankAccount') {
      title = 'Assign To Bank Account';
      titleStyle = styles.inactivateProperty.title;
      body = (
        <AssignToBankAccount
          formName="assign_bank_account_form"
          onSubmit={this.submitBankAccount}
          accounts={this.props.accounts}
        />
      );
      actions.push(
        <FlatButton
          label="Close"
          primary={false}
          onClick={this.props.handleClose}
          style={{ float: 'left' }}
        />,
        <FlatButton
          label="Assign"
          primary={true}
          keyboardFocused={true}
          onClick={this.props.submitRemoteBankAccountForm}
        />
      );
    } else if (this.props.type === dialogTypes.MAINTENANCE_DISPATCH) {
      const toggleAction = !this.props.data.maintenance_dispatch ? 'enable' : 'disable';
      title = getTranslatedString(`landlordPortal.properties.maintenanceDispatch.${toggleAction}`);
      titleStyle = styles.inactivateProperty.title;
      body = (
        <p style={{ fontSize: '14px' }}>
          {getTranslatedString('landlordPortal.properties.maintenanceDispatch.dialogBody')}
        </p>
      );
      actions.push(
        <FlatButton
          label="Close"
          primary={false}
          onClick={this.props.handleClose}
          style={{ float: 'left' }}
        />,
        <FlatButton
          label={getTranslatedString(`landlordPortal.properties.${toggleAction}`)}
          primary={true}
          keyboardFocused={true}
          style={{ color: 'white', backgroundColor: AccentColor() }}
          onClick={() => {
            this.props.toggleMaintenanceDispatchOnProperty(
              this.props.data.id,
              !this.props.data.maintenance_dispatch
            );
            this.props.handleClose();
          }}
        />
      );
    }

    return (
      <div>
        <Dialog
          disableBackdropClick
          title={title}
          open={this.props.open}
          onRequestClose={this.props.handleClose}
          actions={actions}
          modal={true}
          titleStyle={titleStyle}
          bodyStyle={styles.dialog.body}
          contentStyle={styles.dialog.content}
          actionsContainerStyle={styles.dialog.actions}
          className="abstract-dialog"
        >
          {body}
        </Dialog>
      </div>
    );
  }
}

export default connect(
  store => {
    return {};
  },
  dispatch => {
    return {
      submitRemoteBankAccountForm: () => {
        dispatch(submit('assign_bank_account_form'));
      },
      destroyRemoteBankAccountForm: () => {
        dispatch(destroy('assign_bank_account_form'));
      },
      toggleMaintenanceDispatchOnProperty: async (property_id, toggle) =>
        dispatch(await toggleMaintenanceDispatchOnProperty(property_id, toggle)),
    };
  }
)(AbstractDialog);
